export default "__VITE_PUBLIC_ASSET__9ffef4f3__"